export default function ($translateProvider) {
	'ngInject';

	$translateProvider
		.translations('bg', {
			'CONTACTS': {
				'LABEL': 'Контакти',
				'EMAIL': 'Имейл',
				'PHONE': 'Телефон',
				'ADDRESS': 'Пощенски адрес',
				'ADDRESS_OPT': {
					'PARAGRAPH_ONE': 'Автогара "Сердика"',
					'PARAGRAPH_TWO': 'гр. София, ПК: 1202',
					'PARAGRAPH_THREE': 'Трафик маркет - централен офис 41',
					'PARAGRAPH_FOUR': 'Трафик маркет - офис - каса 87'
				}
			}
		})
		.translations('en', {
			'CONTACTS': {
				'LABEL': 'Contacts',
				'EMAIL': 'E-mail',
				'PHONE': 'Phone',
				'ADDRESS': 'Postal address',
				'ADDRESS_OPT': {
					'PARAGRAPH_ONE': 'Busstation "Serdika"',
					'PARAGRAPH_TWO': 'Sofia, Bulgaria, Postcode: 1202',
					'PARAGRAPH_THREE': 'Traffic Market - Head office 41',
					'PARAGRAPH_FOUR': 'Traffic Market - pay desk office 87'
				}
			}
		})
		.translations('cz', {
			'CONTACTS': {
				'LABEL': 'Kontakty',
				'EMAIL': 'Email',
				'PHONE': 'Telefon',
				'ADDRESS': 'Poštovní adresa',
				'ADDRESS_OPT': {
					'PARAGRAPH_ONE': 'Autobusové nádraží "Serdika"',
					'PARAGRAPH_TWO': 'Sofie, : 1202',
					'PARAGRAPH_THREE': 'Trafik market – ústřední kancelář 41',
					'PARAGRAPH_FOUR': 'Тrafik market - kancelář - pokladna 87'
				}
			}
		})
		.translations('hu', {
			'CONTACTS': {
				'LABEL': 'Kapcsolat',
				'EMAIL': 'Email',
				'PHONE': 'Telefonszámaink',
				'ADDRESS': 'Postai címek',
				'ADDRESS_OPT': {
					'PARAGRAPH_ONE': 'Busstation "Serdika"',
					'PARAGRAPH_TWO': 'Sofia, Bulgaria, Postcode: 1202',
					'PARAGRAPH_THREE': 'Traffic Market – központi iroda 41.sz.iroda',
					'PARAGRAPH_FOUR': 'Traffic Market - jegyértékesítés 87.sz.iroda'
				}
			}
		});
}



/** WEBPACK FOOTER **
 ** ./client/public/main/contacts/contacts.locale.js
 **/